import styled, { css } from "styled-components"

const primaryColor = css`
    color:#448487
`
const Homepage = styled.div`
    margin:0 auto;
    ${primaryColor};

`
export default Homepage